/**
 * Resolves an asset path against the widget's origin when running as an
 * embedded widget, so `/assets/logo.png` becomes
 * `http://cdn.example.com/assets/logo.png` instead of resolving against the
 * host page's origin.
 *
 * The base URL is set in main.tsx before React renders.
 */
export function assetUrl(path: string): string {
  const base = (window as { __WIDGET_ASSET_BASE__?: string }).__WIDGET_ASSET_BASE__ ?? ''
  return base + path
}
